import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "hiddenRrule",
    "recurrence",
    "saveModal",
    "thisRadio",
    "allRadio",
  ];
  static values = { rrule: String, recurrence: Boolean };

  saveRecurring(event) {
    if (this.recurrenceValue) {
      event.preventDefault();
      const dialog = new mdc.dialog.MDCDialog(this.saveModalTarget);
      const hiddenRrule = this.hiddenRruleTarget.value;
      if (this.rruleValue === hiddenRrule) {
        // No rrule change occurred
        this.thisRadioTarget.disabled = false;
        this.thisRadioTarget.checked = true;
        this.allRadioTarget.checked = false;
      } else {
        // rrule is different; not allowed to chose only this event
        this.thisRadioTarget.disabled = true;
        this.thisRadioTarget.checked = false;
        this.allRadioTarget.checked = true;
      }

      dialog.open();
    }
  }
}
